import { useCallback, useMemo } from 'react'

import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { UserGroup } from 'types/graphql'

const options: SelectOption<UserGroup>[] = [
  {
    label: 'Admin',
    value: 'Admin',
    sublabel: 'Can perform all actions on all records in the modules they have access to',
  },
  {
    label: 'Employee',
    value: 'Employee',
    sublabel:
      'Can perform a limited set of actions on all records in the modules they have access to',
  },
  {
    label: 'Reviewer',
    value: 'Reviewer',
    sublabel:
      'Can only view tasks and inspections assigned to them. Cannot view a list of all records in the module',
  },
]

const getOptionKey = (option: SelectOption<UserGroup>) => option.value

type Props = {
  caption?: string
  errorMessage?: string
  isInvalid?: boolean
  isRequired?: boolean
  label?: string
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onValueChange: (value: UserGroup | undefined) => void
  value: UserGroup | undefined
}
const StaffUserGroupSelect = ({
  caption,
  errorMessage,
  isInvalid,
  isRequired,
  label,
  onBlur,
  onValueChange,
  value,
}: Props) => {
  const selectedOption = useMemo(() => options.find((o) => o.value === value), [value])

  const handleSelectedOptionChange = useCallback(
    (option: SelectOption<UserGroup> | undefined) => {
      onValueChange(option?.value ?? undefined)
    },
    [onValueChange]
  )

  return (
    <Select
      {...(label ? { label } : { ariaLabel: 'Group' })}
      caption={caption}
      errorMessage={errorMessage}
      getOptionKey={getOptionKey}
      isInvalid={isInvalid}
      isRequired={isRequired}
      onBlur={onBlur}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={options}
      selectedOption={selectedOption}
    />
  )
}

export default React.memo(StaffUserGroupSelect)
